"use client";

import Breadcrumb, { BreadcrumbItem } from "@/components/ui/breadcrumbs";
import { CustomTranslations as Messages } from "@/messages/custom/custom-translations-interface";
import { AlertTriangle, BookOpenCheck, MapPinned, Send, Wallet } from "lucide-react";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { useTranslations } from "use-intl";
type UatBreadCrumbProps = {
  basePath: string;
  baseCrumbs: BreadcrumbItem[];
};
export default function UatBreadCrumb(props: UatBreadCrumbProps) {
  const t = useTranslations("institution");
  const pathname = usePathname();
  const crumbs = useMemo(() => {
    const [_bp, rest] = pathname.split(props.basePath);
    const tabs = rest!.split("/").filter(Boolean);
    const aug: BreadcrumbItem[] = tabs.filter(tab => recognizedTabs[tab as RecognizedTab]).map(tab => {
      const recognizedTab = recognizedTabs[tab as RecognizedTab];
      return {
        href: `${props.basePath}/${tab}`,
        label: t(recognizedTab.tl),
        icon: <recognizedTab.icon size={20} />
      };
    });
    return [...props.baseCrumbs, ...aug];
  }, [pathname, props.basePath, props.baseCrumbs, t]);
  return <Breadcrumb items={crumbs} data-sentry-element="Breadcrumb" data-sentry-component="UatBreadCrumb" data-sentry-source-file="UatBreadCrumb.tsx" />;
}

// TODO: add subtabs, such as form name if necessary
export const recognizedTabs = {
  "send-request": {
    tl: "sendRequest",
    href: "send-request",
    icon: Send
  },
  "new-payment": {
    tl: "newPayment",
    href: "new-payment",
    icon: Wallet
  },
  "issues-and-reports": {
    tl: "newPayment",
    href: "issuesAndReports",
    icon: AlertTriangle
  },
  transparency: {
    tl: "transparency",
    href: "transparency",
    icon: BookOpenCheck
  }
} satisfies Record<string, {
  tl: keyof Messages["institution"];
  href: string;
  icon: any;
}>;
export type RecognizedTab = keyof typeof recognizedTabs;